import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-206">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-207">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-208" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-209">
            {/* Header */}
            <div className="flex items-center justify-between p-5 md:p-6 border-b border-maternal-beige flex-shrink-0" data-id="element-210">
              <h2 className="text-xl md:text-2xl font-bold text-maternal-brown font-heading" data-id="element-211">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-maternal-beige transition-colors text-maternal-lightBrown" aria-label="Cerrar" data-id="element-212">
                <X className="w-5 h-5" data-id="element-213" />
              </button>
            </div>

            {/* Content */}
            <div className="p-5 md:p-6 overflow-y-auto text-maternal-lightBrown text-sm md:text-base leading-relaxed space-y-4 font-body" data-id="element-214">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}